<template>
    <div class="animated fadeIn">
        <CCard>
            <CCardHeader><font-awesome-icon icon="paperclip"/> Templates
            </CCardHeader>
            <CCardBody>
                <CTabs :active-tab="my_tab" @update:activeTab="changeTab">
                    <br>  
                    <CTab>
                        <template slot="title">
                            Active Template/s <CBadge color="success">( {{ [...new Set(dt_lists_active.map((item) => item.name))].length }} )</CBadge>
                        </template>
                        <CRow>
                            <CCol lg="12">
                                <CDataTable
                                    :items="dt_lists_active"
                                    :fields="dt_lists_fields"
                                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                                    :items-per-page="10"
                                    border
                                    items-per-page-select
                                    sorter
                                    pagination
                                    hover
                                    :loading="this.table_loading"
                                >
                                <template slot="no-items-view" v-if="this.table_loading">
                                    <center>
                                        <CSpinner
                                            style="width:4rem;height:4rem;"
                                            color="info"
                                        />
                                    </center>
                                </template>
                                <template #icon="{item}">
                                    <td>
                                        <center>
                                            <CIcon :name="item.icon" size="xl" />
                                        </center>
                                    </td>
                                </template>
                                <template #name="{item}">
                                    <td :title="item.name">                
                                        {{item.name.length > 30 ? item.name.substring(0, 30) + '...' :  item.name}}
                                    </td>
                                </template>
                                <template #description="{item}">
                                    <td :title="item.description">                
                                        {{item.description.length > 15 ? item.description.substring(0, 15) + '...' :  item.description}}
                                    </td>
                                </template>
                                <template #created_at="{item}">
                                    <td>
                                        {{ item.created_at }}
                                    </td>
                                </template>
                                <template #Action="{item}">
                                    <td>
                                        <router-link :to="{path: `/${$store.getters['getOrganizationName']}/drs/document-template/${item.id}`}">
                                            <CButton 

                                                color="info" 
                                                shape="pill" 
                                                size="sm"
                                            >
                                                <font-awesome-icon icon="cog"/> Manage
                                            </CButton>
                                        </router-link>
                                        &nbsp;
                                        <CButton 
                                            v-if="$store.getters['can']('document-template-copy-template')"
                                            color="warning" 
                                            shape="pill" 
                                            size="sm"
                                            @click="copyTemplate(item.id)"
                                        >
                                                <!-- :icon="ti_being_copied == null || !copying ? 'copy' : ti_being_copied == item.id && copying ? 'circle-notch' : 'save'" -->

                                            <font-awesome-icon icon="copy"/> Copy Template
                                        </CButton>
                                    </td>
                                </template>
                                <template #signatory_lock="{item}">
                                    <td>
                                        <small>
                                            <CBadge :color="getColorStatus(item.signatory_lock)">
                                                {{item.signatory_lock[0].toUpperCase() + item.signatory_lock.slice(1).toLowerCase()}}
                                            </CBadge>
                                        </small>
                                    </td>
                                </template>
                                </CDataTable>
                            </CCol>
                        </CRow>
                    </CTab>
                    <CTab>
                        <template slot="title">
                            Inactive Template/s <CBadge color="danger">( {{ [...new Set(dt_lists_inactive.map((item) => item.name))].length }} )</CBadge>
                        </template>
                        <CRow>
                            <CCol lg="12">
                                <CDataTable
                                    :items="dt_lists_inactive"
                                    :fields="dt_lists_fields"
                                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                                    :items-per-page="10"
                                    border
                                    items-per-page-select
                                    sorter
                                    pagination
                                    :loading="this.table_loading"
                                >
                                    <template slot="no-items-view" v-if="this.table_loading">
                                        <center>
                                            <CSpinner
                                                style="width:4rem;height:4rem;"
                                                color="info"
                                            />
                                        </center>
                                    </template>
                                    
                                    <template #signatory_lock="{item}">
                                        <td>
                                            <small>
                                                <CBadge :color="getColorStatus(item.signatory_lock)">
                                                    {{item.signatory_lock[0].toUpperCase() + item.signatory_lock.slice(1).toLowerCase()}}
                                                </CBadge>
                                            </small>
                                        </td>
                                    </template>
                                    <template #name="{item}">
                                        <td :title="item.name">                
                                            {{item.name.length > 30 ? item.name.substring(0, 30) + '...' :  item.name}}
                                        </td>
                                    </template>
                                    <template #description="{item}">
                                        <td :title="item.description">                
                                            {{item.description.length > 15 ? item.description.substring(0, 15) + '...' :  item.description}}
                                        </td>
                                    </template>
                                    <template #updated_at="{item}">
                                        <td>
                                            <small>{{ item.updated_at }}</small>
                                        </td>
                                    </template>
                                    <template #Action="{item}">
                                        <td >
                                            <router-link :to="{path: `/${$store.getters['getOrganizationName']}/drs/document-template/${item.id}`}">
                                                <CButton 

                                                    color="info" 
                                                    shape="pill" 
                                                    size="sm"
                                                >
                                                    <font-awesome-icon icon="cog"/> Manage
                                                </CButton>
                                            </router-link>
                                            &nbsp;
                                            <template v-if="$store.getters['can']('restore-document-template')">
                                                <CButton 
                                                        size="sm"
                                                        shape="pill"
                                                        color="success" 
                                                        :disabled="restoring ? (item.id == restoring_id ? true : false) : false"
                                                        @click="restore(item)"
                                                    >

                                                    <font-awesome-icon :icon="restoring ? (item.id == restoring_id ? 'circle-notch' : 'trash-restore') : 'trash-restore'" 
                                                                :pulse="restoring ? (item.id == restoring_id ? true : false) : false"/> Restore
                                                </CButton>
                                            </template>
                                            <template v-else>
                                                <i><b>No permission to restore.</b></i>
                                            </template>
                                        </td>
                                    </template>  
                                </CDataTable>
                            </CCol>
                        </CRow>
                    </CTab>
                </CTabs>




            </CCardBody>
        </CCard>   
    </div>
</template>
<script>
// import CHideShowBtn from '../../components/CHideShowBtn'
export default {
    name: 'DocumentTemplateLists',
    // components:{
    //     CHideShowBtn
    // },
    data() {
        return {
            table_loading: true,
            dt_lists_all: [],
            restoring: false,
            my_tab: 0,
            restoring_id: null,
        }
    },
    created() {
        this.getDocumentTemplates();
        this.$emit('activeTab', 0);
    },
    computed: {
        dt_lists_active: function() {
            return this.dt_lists_all.filter((item) => item.deleted_at == null);
        },

        dt_lists_inactive: function() {
            return this.dt_lists_all.filter((item) => item.deleted_at != null);
        },

        dt_lists_fields: function () {
            let custom_fields= [
                { key: 'name', label: 'Name'},
                { key: 'category' },
                { key: 'description' },
            ]
            
            if(this.my_tab) {
                custom_fields.push({ key: 'updated_at', label: 'Inactivity Date' })
            } else {
                custom_fields.push({ key: 'created_at', label: 'Date Added' })
            }
            
            custom_fields.push({ key: 'signatory_lock'})

            if(this.$store.getters.can('view-document-template')) {
                custom_fields.push({ key: 'Action', sorter: false})
            }
            return custom_fields;
        }
    },
    methods: {
        changeTab: function (item) {
            this.my_tab = item
        },      
        restore: function (item) {
            this.restoring = true
            this.restoring_id = item.id;
            this.$Progress.start()
            axios.post('/drs/document-template/restore/' + item.id, {validateStatus: () => true})
            .then(response => {
                if(response.status == 200) {
                    this.$swal({
                        toast: true,
                        position: 'top-right',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: `${item.name} has been restored.`,
                        showConfirmButton: false,
                        timerProgressBar: true,
                    })
                    this.dt_lists_all.filter(obj => obj.id === item.id)[0].deleted_at = null;
                    this.$Progress.finish() 
                }
            })
        },
        copyTemplate: function (id) {
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: "You are trying to copy this template.",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => { 
                    this.$Progress.start()
                    return axios.post('/drs/document-template/copy-template/'+id, {validateStatus: () => true})
                    .then(response => {
                        if(response.status == 200) {
                            this.$swal({
                                icon: "success",
                                title: "Success!",
                                text: `${response.data.data.name} Template has sucessfully added. Do you want to open this template?`,
                                showCancelButton: true,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "Yes, open template",
                            }).then((result) => {
                                if(result.value){ 
                                    this.$router.push(`/${this.$store.getters.getOrganizationName}/drs/document-template/${response.data.data.id}`);
                                } else {
                                    this.getDocumentTemplates()
                                }
                            })
                            this.$Progress.finish();
                        }
                    })
                }
            }).then((result) => {
                if(!result.value){
                    this.$swal('Cancelled!','','error');
                }
            })
        },
        getDocumentTemplates: function () {
            this.$Progress.start()
            axios.get('/drs/document-template/list', {validateStatus: () => true})
            .then(response => {
                if(response.status == 200) {
                    this.dt_lists_all = []
                    for (let i = 0; i < response.data.data.length; i++) {
                        let row = {
                                id:  response.data.data[i].id, 
                                name:  response.data.data[i].name, 
                                category:  response.data.data[i].document_template_category_id != null ? response.data.data[i].document_template_category.category : '', 
                                description:  response.data.data[i].description, 
                                signatory_lock:  response.data.data[i].signatory_lock == 1 ? 'locked' : 'unlocked', 
                                deleted_at: response.data.data[i].deleted_at,
                                created_at: this.changeDateFormatV2(response.data.data[i].created_at),
                                updated_at: this.changeDateFormat(response.data.data[i].updated_at)
                        }
                        this.dt_lists_all.push(row)
                    }
                    this.table_loading = false;
                    this.$Progress.finish()
                }
            })
        },
    },
}
</script>